import { useQuery } from "@apollo/client";
import { MY_MAILBOX } from "../mailbox.queries";
import { MyMailboxQuery } from "../../../__generated__/MyMailboxQuery";

export const useMyMailbox = () => {
  return useQuery<MyMailboxQuery>(MY_MAILBOX);
};
